// extracted by mini-css-extract-plugin
module.exports = {"buy_now":"BuyNow_buy_now__OTmIS","buy_now__title":"BuyNow_buy_now__title__0qhcL","buy_now__links":"BuyNow_buy_now__links__kHrdx"};